module.exports = __webpack_public_path__ + "static/media/logo-MBA.d349611d.svg";